import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
export function Register() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const defaultRole = queryParams.get('role') || 'buyer';
  const [role, setRole] = useState(defaultRole);
  return <div className="mt-8" data-id="element-885">
      <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-886">
        <h2 className="mb-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-887">
          Create your account
        </h2>
        <form className="space-y-6" action="#" method="POST" data-id="element-888">
          <div data-id="element-889">
            <label htmlFor="account-type" className="block text-sm font-medium text-gray-700" data-id="element-890">
              Account Type
            </label>
            <div className="mt-1" data-id="element-891">
              <div className="flex space-x-4" data-id="element-892">
                <div className="flex items-center" data-id="element-893">
                  <input id="buyer" name="account-type" type="radio" checked={role === 'buyer'} onChange={() => setRole('buyer')} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-894" />
                  <label htmlFor="buyer" className="ml-2 block text-sm text-gray-900" data-id="element-895">
                    Buyer (I need packaging)
                  </label>
                </div>
                <div className="flex items-center" data-id="element-896">
                  <input id="supplier" name="account-type" type="radio" checked={role === 'supplier'} onChange={() => setRole('supplier')} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-897" />
                  <label htmlFor="supplier" className="ml-2 block text-sm text-gray-900" data-id="element-898">
                    Supplier (I supply packaging)
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2" data-id="element-899">
            <div data-id="element-900">
              <label htmlFor="first-name" className="block text-sm font-medium text-gray-700" data-id="element-901">
                First name
              </label>
              <div className="mt-1" data-id="element-902">
                <input type="text" id="first-name" name="first-name" autoComplete="given-name" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-903" />
              </div>
            </div>
            <div data-id="element-904">
              <label htmlFor="last-name" className="block text-sm font-medium text-gray-700" data-id="element-905">
                Last name
              </label>
              <div className="mt-1" data-id="element-906">
                <input type="text" id="last-name" name="last-name" autoComplete="family-name" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-907" />
              </div>
            </div>
          </div>
          <div data-id="element-908">
            <label htmlFor="company" className="block text-sm font-medium text-gray-700" data-id="element-909">
              Company name
            </label>
            <div className="mt-1" data-id="element-910">
              <input id="company" name="company" type="text" autoComplete="organization" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-911" />
            </div>
          </div>
          <div data-id="element-912">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-913">
              Email address
            </label>
            <div className="mt-1" data-id="element-914">
              <input id="email" name="email" type="email" autoComplete="email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-915" />
            </div>
          </div>
          <div data-id="element-916">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-917">
              Password
            </label>
            <div className="mt-1" data-id="element-918">
              <input id="password" name="password" type="password" autoComplete="new-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-919" />
            </div>
          </div>
          <div data-id="element-920">
            <label htmlFor="password-confirm" className="block text-sm font-medium text-gray-700" data-id="element-921">
              Confirm password
            </label>
            <div className="mt-1" data-id="element-922">
              <input id="password-confirm" name="password-confirm" type="password" autoComplete="new-password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-923" />
            </div>
          </div>
          <div className="flex items-center" data-id="element-924">
            <input id="terms" name="terms" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-925" />
            <label htmlFor="terms" className="ml-2 block text-sm text-gray-900" data-id="element-926">
              I agree to the{' '}
              <a href="#" className="text-blue-600 hover:text-blue-500" data-id="element-927">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="#" className="text-blue-600 hover:text-blue-500" data-id="element-928">
                Privacy Policy
              </a>
            </label>
          </div>
          <div data-id="element-929">
            <Link to="/dashboard" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-930">
              Create account
            </Link>
          </div>
        </form>
        <div className="mt-6" data-id="element-931">
          <div className="relative" data-id="element-932">
            <div className="absolute inset-0 flex items-center" data-id="element-933">
              <div className="w-full border-t border-gray-300" data-id="element-934" />
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-935">
              <span className="px-2 bg-white text-gray-500" data-id="element-936">
                Or continue with
              </span>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-937">
            <div data-id="element-938">
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-939">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-940">
                  <path fillRule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" data-id="element-941" />
                </svg>
              </a>
            </div>
            <div data-id="element-942">
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-943">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-944">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" data-id="element-945" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-946">
          <p className="text-sm text-gray-600" data-id="element-947">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-948">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>;
}